/**
 * ReviewLoadStates — the loading and failure states both Needs-review pages
 * share (BON-381). A failed load is SHOWN, never swallowed into an empty
 * queue: "nothing to review" and "we couldn't ask" must not look the same on a
 * page whose whole job is telling an operator that something needs attention.
 */
import { Spinner } from '../dashboards/primitives';

export function ReviewLoading({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      role="status"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 0' }}
    >
      <Spinner size={22} />
      <span
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          overflow: 'hidden',
          clip: 'rect(0 0 0 0)',
        }}
      >
        {label}
      </span>
    </div>
  );
}

export function ReviewError({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div
      role="alert"
      className="nb-card nb-card-tight"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        borderLeft: '3px solid var(--nb-warn)',
      }}
    >
      <span style={{ flex: 1, fontSize: 13, color: 'var(--nb-ink-2)' }}>{message}</span>
      {onRetry && (
        <button type="button" className="nb-btn" style={{ height: 28 }} onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
